<app-content-shell [resizablePanel]="true">

  <app-header mainHeader />

  <app-panel-header panelHeader [title]="'Projects'">
    <button action mat-icon-button *allowedRole="'admin'" (click)="addNewItem()" matTooltip="Add project">
      <mat-icon>add</mat-icon>
    </button>
  </app-panel-header>

  <div panelContent>
    @for (project of sortedProjects; track project._id) {
      <app-list-item [selected]="selectedProject?._id === project._id" [hasMenu]="true" (click)="selectProject(project)">
        <span itemTitle>{{ project.title }}</span>
        <button
          itemSuffix
          type="button"
          class="project-list__info"
          [class.project-list__info--empty]="!projectDescription(project)"
          [matTooltip]="projectDescriptionTooltip(project)"
          matTooltipPosition="above"
          matTooltipShowDelay="200"
          [attr.aria-label]="projectDescriptionAria(project)"
          (click)="$event.stopPropagation()"
        >
          <mat-icon>info_outline</mat-icon>
        </button>
        <ng-container itemMenu>
          <button mat-menu-item type="button" (click)="onDeleteProject(project, $event)" *allowedRole="'admin'">
            <mat-icon svgIcon="delete-section"></mat-icon>
            <span>Delete</span>
          </button>
        </ng-container>
      </app-list-item>
    }
    @if (projects.length === 0) {
      <p class="empty-indicator">No projects yet</p>
    }
  </div>

  <div mainContent class="projects-main-content full-height-content">
    @if (selectedProject) {
      <app-projects-content [selectedItem]="selectedProject" />
    } @else {
      <app-empty-state icon="folder_open" title="Select a project" subtitle="Choose a project from the list to view its details." />
    }
  </div>

</app-content-shell>
